import axios from "axios";
import { API_HEADERS } from "../../constants";
import { REWARDS_BASE_URL } from "../../api-config";

export const getOrdersToPickCount = async () => {
  try {
    const result = await axios.get(`${REWARDS_BASE_URL}/dashboard/orders/status/count?forStatus=ToPick`, {
      headers: API_HEADERS,
    });

    return result.data;
  } catch (error) {
    // Handle error appropriately (e.g., logging, error messages)
    console.error("Error fetching orders to be picked count:", error);
    throw error; // Re-throw the error to be handled by the caller
  }
};

export const getOrdersToProcessCount = async () => {
  try {
    const result = await axios.get(`${REWARDS_BASE_URL}/dashboard/orders/status/count?forStatus=ToProcess`, {
      headers: API_HEADERS,
    });

    return result.data;
  } catch (error) {
    // Handle error appropriately (e.g., logging, error messages)
    console.error("Error fetching orders to be counted count:", error);
    throw error; // Re-throw the error to be handled by the caller
  }
};

export const getIssueOrdersCount = async () => {
  try {
    const result = await axios.get(`${REWARDS_BASE_URL}/dashboard/orders/status/count?forStatus=InIssue`, {
      headers: API_HEADERS,
    });

    return result.data;
  } catch (error) {
    // Handle error appropriately (e.g., logging, error messages)
    console.error("Error fetching orders to be counted count:", error);
    throw error; // Re-throw the error to be handled by the caller
  }
};

export const getClickAndCollectCount = async () => {
  try {
    const result = await axios.get(`${REWARDS_BASE_URL}/dashboard/orders/status/count?forStatus=ClicknCollect`, {
      headers: API_HEADERS,
    });

    return result.data;
  } catch (error) {
    // Handle error appropriately (e.g., logging, error messages)
    console.error("Error fetching orders to be clickncollect count:", error);
    throw error; // Re-throw the error to be handled by the caller
  }
};

export const getLastOrderTimeStamp = async () => {
  try {
    const result = await axios.get(`${REWARDS_BASE_URL}/dashboard/orders/status/lastOrderTimeStamp`, {
      headers: API_HEADERS,
    });

    return result.data;
  } catch (error) {
    // Handle error appropriately (e.g., logging, error messages)
    console.error("Error fetching date and time:", error);
    throw error; // Re-throw the error to be handled by the caller
  }
};
